import React, { CSSProperties, useEffect } from 'react';
import { useCallback, useMemo } from 'react';
import { createEditor, Transforms } from 'slate';
import { Slate, withReact } from 'slate-react';

import { useMetrics } from '../../hooks/useMetrics';
import {
  Element,
  Leaf,
  parseStringToSlateObject,
  SlateEditable,
  SlateWrapper,
  TEXT_ALIGN_TYPES,
} from './slateUtil';

const SlateRichTextViewer = ({
  content,
  id,
  style,
  forceState,
  showPlaceHolder,
}: {
  content?: string | null;
  id: string;
  style?: CSSProperties;
  showPlaceHolder?: boolean;
  forceState?: { align?: TEXT_ALIGN_TYPES; color?: string; size: number }; // Forcing state of text
}) => {
  const metrics = useMetrics();
  const editor = useMemo(() => withReact(createEditor()), []);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderElement = useCallback((props: any) => <Element {...props} />, []);
  const renderLeaf = React.useCallback(
    (props: any) => {
      return <Leaf {...props} metrics={metrics} />;
    },
    [metrics],
  );
  const loadedContent = useMemo(() => {
    return parseStringToSlateObject(content);
  }, [content]);

  useEffect(() => {
    Transforms.deselect(editor); // Prevent offset bug in view
    const contentToLoad = loadedContent.map(content => ({ ...content, ...forceState }));
    editor.children = contentToLoad;
    editor.onChange();
  }, [forceState, loadedContent, editor]);

  return (
    <SlateWrapper style={style ? style : {}}>
      <span translate="no">
        <Slate editor={editor} value={loadedContent}>
          <SlateEditable
            id={id}
            readOnly={true}
            $readOnly={true}
            style={style}
            placeholder={showPlaceHolder ? 'Enter text...' : undefined}
            renderElement={renderElement}
            renderLeaf={renderLeaf}
          ></SlateEditable>
        </Slate>
      </span>
    </SlateWrapper>
  );
};

export default SlateRichTextViewer;
